
import React, { Component } from 'react';
import './active-homework.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants, AccessRights } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import SessionCache from '../../routes/session-cache';
import ReactTooltip from "react-tooltip";

class ActiveHomeworkComponent extends Component {

    accessRights = SessionCache.getAllowedModule()

    dueDate = ''

    state = {
        dueDate : ''
    }

    onClickArchive = () => {
        this.props.delegate.onClickArchive && this.props.delegate.onClickActivate(this.props.selectedItem, this.state.dueDate ? this.dueDate : '')
    }

    onCLickCancel = () => {
        this.props.onClose && this.props.onClose()
    }

    handleDateEvent = (event, picker) => {
        this.dueDate = picker.startDate ? (new Date(new Date(picker.startDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : ''
        this.setState({dueDate : new Date(picker.startDate).toLocaleDateString()})
    }

    checkEditCondtion() {
        if (this.props.type == 'ADAPTIVE') {
            return this.accessRights[AccessRights.ADAPTIVE_HOMEWORK_EDIT]
        } else {
            return this.accessRights[AccessRights.STANDARD_HOMEWORK_EDIT]
        }
    }


    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="archive-modal">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="title">{this.props.title || "Are you sure you want to Archive this item?"}</div>
                        </div>
                        <div className='text-center mt-3' onMouseEnter={ReactTooltip.rebuild}>
                            <span className='header-label' >Due: <strong className="pr-2">{this.state.dueDate ? this.state.dueDate : this.props.selectedItem.dueDate}</strong>
                                {
                                    this.checkEditCondtion() ?
                                        <DateRangePicker onApply={(event, picker) => this.handleDateEvent(event, picker)}
                                            initialSettings={{ singleDatePicker: true, minDate: this.startDate ? this.startDate : new Date() }}
                                        >
                                            <img className="edit-icon" data-tip={'Edit Due Date'} src={getImageSource(ImageConstants.EDIT)} />
                                        </DateRangePicker>
                                        : ""
                                }
                            </span>
                        </div>

                        <div className="text-center py-4">
                            <button className="cw-button-primary light mr-2" onClick={this.onCLickCancel}>
                                Cancel
                            </button>
                            <button className="cw-button-primary" onClick={this.onClickArchive}>
                                Mark As Active
                            </button>
                        </div>
                    </div>
                    <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
                </ModalBody>

            </Modal >
        );
    }
}

export default ActiveHomeworkComponent;